<template>
  <div>
    <h4>読まれた本たち一覧</h4>
      <div>
        <b-card-group deck>
          <div class="kowai" v-for="(post, index) in posts" :key="index">
            <b-card style="background-color: olivedrab;" text-variant="white" header="Book" class="text-center">
              <div class="teach" style="margin-right: 50px; display: inline-flex;">
                <p style="font-size: 5px; margin-right: 10px; margin-top: 4px;">本の名前</p>
                <h4>{{post.title}}</h4>
              </div>
              <p class="mt-2">オススメ度: {{ post.recommend }}</p>
              <div class="teach" style="margin-right: 50px; display: inline-flex;">
                <p style="font-size: 5px; margin-right: 10px; margin-top: 4px;">本のタイプ</p>
                <b-card-text style="font-size: 14px;">{{post.type}}</b-card-text>
              </div>
              <div class="teach" style="margin-right: 50px; display: inline-flex;">
                <p style="font-size: 5px; margin-right: 10px; margin-top: 4px;">メモ</p>
                <b-card-text>{{post.comment}}</b-card-text>
              </div>
              <div v-if="isSignedIn">
                <div v-if="post.user_id === user.uid">
                  <b-button style="margin-right: 15px;" variant="warning" @click.prevent="edit(post)">編集</b-button>
                  <b-button variant="danger" @click.prevent="remove(post.id)">削除</b-button>
                </div>
                <div v-else>
                  <b-button variant="warning" v-if="post.status" @click.prevent="good(post)">いいね削除</b-button>
                  <b-button variant="warning" v-else @click.prevent="good(post)">いいね</b-button>
                </div>
              </div>
            </b-card>
            
          </div>
          <div id="overlay" v-if="showModal" @click.prevent="closeModal">
              <div @click.stop id="content">
                <h3>編集</h3>
                <!-- <span @click.prevent="closeModal">X</span> -->
                <form @submit.prevent="update(edit_post)">
                  <b-form-group
                    id="input-group-1"
                    label="本のタイトル"
                    label-for="input-1"
                  >
                    <b-form-input
                      v-model="edit_post.title"
                      type="text"
                      required
                      placeholder="吾輩は猫である...etc"
                    ></b-form-input>
                  </b-form-group>
                  <div>
                    <b-form-select v-model="edit_post.type" :options="options" class="mb-3">
                      <template v-slot:first>
                        <b-form-select-option :value="edit_post.type" disabled>-- 本のタイプ --</b-form-select-option>
                      </template>
                    </b-form-select>
                  </div>
                  <div>
                    <b-form-rating v-model="edit_post.recommend"></b-form-rating>
                    <p class="mt-2">オススメ度: {{ edit_post.recommend }}</p>
                  </div>
                  <div>
                    <b-col sm="10">
                      <b-form-textarea
                        id="textarea-default"
                        placeholder="読んでみての一言"
                        v-model="edit_post.comment"
                        required
                      ></b-form-textarea>
                      <!-- <div class="voice-box">
                        <b-button @click="speechIn" pill variant="primary">{{startText}}</b-button>
                        <b-button @click="speechOut" pill>停止</b-button>
                      </div> -->
                    </b-col>
                  </div>
                  <b-button style="margin-top: 8px;" variant="primary" type="submit">更新</b-button>
                </form>
              </div>
            </div>
        </b-card-group>
      </div>
  </div>
</template>

<script>
// const recognition = new window.webkitSpeechRecognition();
// recognition.continuous = true;
// recognition.lang = 'ja';

export default {
  data() {
    return {
      // startText: '音声入力開始',
      // record: recognition,
      showModal: false,
      edit_post: {
        comment: ''
      },
      type: null,
      options: [
        { value: '自己啓発、マインド系', text: '自己啓発、マインド系' },
        { value: '健康、睡眠、ワークアウト系', text: '健康、睡眠、ワークアウト系' },
        { value: 'ビジネス系、経済系', text: 'ビジネス系、経済系' },
        { value: 'プログラミング系', text: 'プログラミング系' },
        { value: '小説', text: '小説' },
        { value: 'エロ本', text: 'エロ本' },
      ],
    }
  },
  computed: {
    posts() {
      const arr = this.$store.state.posts
      return arr.sort(function(a,b) {
          return (a.createdAt < b.createdAt ? 1 : -1);
      });
    },
    user() {
      return this.$store.state.user
    },
    isSignedIn() {
      return this.$store.getters.isSignedIn
    }
  },
  created() {
    this.$store.dispatch('getAll')

    // this.record.onresult = (event) => {
    //   if(event.results.length > 0) {
    //     if(this.edit_post.comment === null) {
    //       this.edit_post.comment = event.results[0][0].transcript;
    //     } else {
    //       this.edit_post.comment += event.results[0][0].transcript;
    //     }
    //   }
    // }
  },
  methods: {
    edit(post) {
      var user = this.$store.state.user
      if(user.uid === post.user_id) {
        this.showModal = true
        this.edit_post = post
      } else {
        alert('作成者のみが編集できます')
      }
    },
    update(post) {
      this.$store.dispatch('editPost', post)
    },
    remove(id) {
      this.$store.dispatch('removePost', id)
    },
    closeModal() {
      this.showModal = false
    },
    good(post) {
      this.$store.dispatch('addGood', post)
    },
    removegood(post) {
      this.$store.dispatch('removeGood', post)
    },
    // speechIn() {
    //   this.record.start()
    //   this.startText = '音声入力中...'
    // },
    // speechOut() {
    //   this.record.stop()
    //   this.startText = "音声入力開始"
    // },
  }
}
</script>

<style scoped>
#overlay{
  /*要素を重ねた時の順番*/
  z-index:1;

  /*画面全体を覆う設定*/
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);

  /*画面の中央に要素を表示させる設定*/
  display: flex;
  align-items: center;
  justify-content: center;

}

#content{
  z-index:2;
  width:50%;
  padding: 1em;
  background-color: burlywood;
  border: 3px solid forestgreen;
  height: 70vh;
  overflow: scroll;

}

span{
  cursor: pointer;
}

.close{
  left: 0;
  top: 0;
  font-size: 20px;
  cursor: pointer;
}

.text-white{
  width: 75%;
  margin: auto;
}

.kowai{
  margin-bottom: 20px;
}

.voice-box{
    margin-top: 10px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-evenly;
  }
</style>